import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import success from "../../assets/img/success.png";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { FormControl } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import {
	resetgetKybReportList,
	getKybReportListReq
} from "../../redux/actions/getKybReportListAction";

import {
	resetgetKybApproveReject,
	getKybApproveRejectReq
} from "../../redux/actions/getKybApproveRejectAction";
import SearchIcon from "@mui/icons-material/Search";
import { useHistory } from "react-router-dom";
import getKybDetails from "./getKybDetails";
import Skeleton from "../../components/Skeleton/Skeleton";
import { Popconfirm, Spin } from "antd";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const KybReport = () => {
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const [verificationId, setVerificationId] = useState("");
	const [parentId, setParentId] = useState("");
	const [verificationStatus, setVerificationStatus] = useState("All");
	const [role, setRole] = useState("Select Role");
	const navigate = useHistory();
	const [pageToggle, setPageToggle] = useState(false);
	const [getKybReportListArray, setGetKybReportListArray] = useState("");
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [getKybReportListStatus, setgetKybReportListStatus] = useState(false);
	const [getKybApprovedorRejectStatus, setgetKybApprovedorRejectStatus] =
		useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [approveRejectDesc, setapproveRejectDesc] = useState('');
	const [notificationApproveReject, setnotificationApproveReject] = useState(false);

	const [page, setPage] = useState(0);
	const classes = useStyles();

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getKybReportListRes = useSelector(
		({ getKybReportList }) => getKybReportList
	);

	const getKybApproveRejectRes = useSelector(
		({ getKybApproveReject }) => getKybApproveReject
	);

	useEffect(() => {
		getKybApproveRejectResFunc();
	}, [getKybApproveRejectRes.data.status]);

	const getKybApproveRejectResFunc = () => {
		if (getKybApprovedorRejectStatus) {
			if (getKybApproveRejectRes.data.status == "Approved") {
				setapproveRejectDesc(getKybApproveRejectRes.data.description)
				setnotificationApproveReject(true);
				gekybReportReq();
			}
			if (getKybApproveRejectRes.data.status == "Reject") {
				setapproveRejectDesc(getKybApproveRejectRes.data.description)
				setnotificationApproveReject(true);
				gekybReportReq();
			}
		}
	};

	const handleAcceptOrRejectReq = (
		customerId,
		role,
		companyId,
		recommendation
	) => {
		// console.log(customerId, role, companyId, recommendation);

		setgetKybApprovedorRejectStatus(true);
		const acceptOrRejectReq = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				customerId: customerId,
				role: role,
				userName: regenerateTokenRes.data.LoginName,
				companyId: companyId,
				recommendation: recommendation
			}
		};
		return dispatch(getKybApproveRejectReq(acceptOrRejectReq, authToken));
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "verificationId") {
			// setVerificationId(value);
			Util.verifyNumber(value)
				? setVerificationId(value)
				: setVerificationId(verificationId);
		}

		if (name === "parentId") {
			// setParentId(value);
			Util.verifyNumber(value) ? setParentId(value) : setParentId(parentId);
		}

		if (name === "verificationStatus") {
			setVerificationStatus(value);
		}

		if (name === "role") {
			setRole(value);
		}
	};

	const gekybReportReq = () => {
		setIsLoading(true);
		setgetKybReportListStatus(true);
		const gekybReportReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},

			actionCustomerMasterRequestVO: {
				verificationId: verificationId,
				customerId: parentId,
				verificationStatus:
					verificationStatus == "All" ? "" : verificationStatus,
				fdtstamp: moment(selectedDate).format("YYYY-MM-DD"),
				tdtstamp: moment(selectedToDate).format("YYYY-MM-DD"),
				role: role == "Select Role" ? "" : role
				// custRegId: "","All" ? "" : value
				// customerId: "",
				// verificationStatus: "",
				// fdtStamp: "",
				// tdtStamp: "",
				// role: "",
			}
		};
		return dispatch(getKybReportListReq(gekybReportReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			gekybReportReq();
		}
	}, [regenerateTokenRes.data.status]);

	const handleDateChange = (date) => {
		setSelectedDate(date);
		if (date > selectedToDate) {
			setSelectedToDate(date)
		}
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const getKybReportListResFunc = () => {
		if (getKybReportListStatus) {
			if (getKybReportListRes.data.status == "success") {
				setIsLoading(false);
				setGetKybReportListArray(
					[].concat(getKybReportListRes.data.customerMasterDetailsRequestVOList)
				);
			}
			if (getKybReportListRes.data.status == "failed") {
				setIsLoading(false);
				setGetKybReportListArray(getKybReportListRes.data);
				if (
					getKybReportListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKybReportListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (getKybReportListRes.data.status == "Not Found") {
				setIsLoading(false);
				setGetKybReportListArray(getKybReportListRes.data);
			}
		}
	};

	useEffect(() => {
		getKybReportListResFunc();
	}, [getKybReportListRes.data.status]);

	useEffect(() => {
		if (getKybReportListRes.data.status == "success") {
			setPage(0);
		}
	}, [getKybReportListRes.data.status]);

	const sendVerificationId = (id, customerId, userRole) => {
		setPageToggle(true);
		navigate.push({
			pathname: `/index/getKybDetails`,
			state: { param1: `${id}`, param2: `${customerId}`, param3: `${userRole}` }
		});
	};

	const notificationClose = () => {
		setnotificationApproveReject(false);
	}

	return (
		<>
			<>
				<Layout>
					<Card>
						{/* <BackButton /> */}
						<Grid
							container
							spacing={2}
							style={{ padding: "25px", marginTop: "2rem" }}
						>
							<Grid item xs={12} sm={12} md={3} lg={3}>
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<DatePicker
											label="From Date"
											format="MM/dd/yyyy"
											// format="yyyy-mm-dd"

											value={selectedDate}
											onChange={handleDateChange}
											disableFuture={true}
										/>
									</LocalizationProvider>
								</FormControl>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<DatePicker
											label="To Date"
											format="MM/dd/yyyy"
											// format="yyyy-mm-dd"
											value={selectedToDate}
											onChange={handleToDateChange}
											disableFuture={true}
											minDate={selectedDate}
										/>
									</LocalizationProvider>
								</FormControl>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Verification Id"
									type="text"
									fullWidth
									value={verificationId || ""}
									name="verificationId"
									// onChange={handleChange}
									onChange={(e) => handleChange(e, "number")}
									style={{ marginTop: "3px" }}
									variant="standard"
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</Grid>
							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Parent Id"
									type="text"
									fullWidth
									value={parentId}
									name="parentId"
									variant="standard"

									// onChange={handleChange}
									onChange={(e) => handleChange(e, "number")}
									style={{ marginTop: "3px" }}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Verification Status"
									type="name"
									fullWidth
									variant="standard"
									name="verificationStatus"
									value={verificationStatus || ""}
									defaultValue={"All" || verificationStatus}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="All" selected="All">
										All
									</MenuItem>
									<MenuItem value="Approve">Approve</MenuItem>
									<MenuItem value="Error">Error</MenuItem>

									<MenuItem value="Failed">Failed</MenuItem>
									<MenuItem value="Pending">Pending</MenuItem>

									<MenuItem value="Reject">Reject</MenuItem>
									<MenuItem value="Review">Review</MenuItem>
								</TextField>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Role"
									type="name"
									fullWidth
									variant="standard"
									name="role"
									value={role || ""}
									defaultValue={"Select Role" || role}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Role" selected="Select Role">
										Select Role
									</MenuItem>
									<MenuItem value="Customer">Customer</MenuItem>
									<MenuItem value="Merchant">Merchant</MenuItem>
									<MenuItem value="Agent">Agent</MenuItem>
									<MenuItem value="Cashier">Cashier</MenuItem>
									<MenuItem value="Store Manage">Store Manage</MenuItem>
								</TextField>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={gekybReportReq}
								>
									Search <SearchIcon />
								</CustomButton>
							</Grid>
						</Grid>

						{/* <Grid
              container
              style={{
                padding: "10px",
                marginTop: "1.5rem",
                marginBottom: "15px",
              }}
            >
              <Grid item md={5}>
                <Button
                  style={{
                    marginLeft: "0.7rem",
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  endIcon={<AiOutlineSearch />}
                  variant="contained"
                  onClick={gekybReportReq}
                >
                  Search
                </Button>
              </Grid>
              <Grid item md={7}></Grid>
            </Grid> */}
					</Card>

					{isLoading ? (
						<LoadingSpinner />
					) : getKybReportListArray.length == undefined ||
						!getKybReportListStatus ? (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Report Table
									</Typography>
								</Grid>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Alert
										className="my-3 tableHeaderColor"
										variant="secondary"
										style={{ color: "white" }}
									>
										No Records Found!
									</Alert>
								</Grid>
							</Grid>
						</Card>
					) : (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="my-3">
									<Table
										className={classes.table}
										size="small"
										aria-label="a dense table"
									>
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Verification Id{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Parent Id
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Role
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Company ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Company Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Timestamp
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Verification Status
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{getKybReportListArray &&
												[]
													.concat(getKybReportListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row) => (
														<TableRow key={row.customerId}>
															<TableCell
																align="center"
																style={{
																	marginTop: "1rem",
																	// marginLeft: "rem",
																	cursor: "pointer",
																	fontWeight: "600"
																}}
																className="themeColor"
																onClick={() =>
																	sendVerificationId(
																		row.verificationId,
																		row.customerId,
																		row.userRole
																	)
																}
															>
																{row.verificationId}
															</TableCell>

															<TableCell align="center">
																{row.customerId}
															</TableCell>
															<TableCell align="center">
																{row.userRole}
															</TableCell>
															<TableCell align="center">
																{row.companyId}
															</TableCell>

															<TableCell align="center">
																{row.companyName}
															</TableCell>
															<TableCell align="center">
																{row.requestTime}
															</TableCell>
															<TableCell align="center">
																{row.verificationStatus}
															</TableCell>

															{row.verificationStatus == "Pending" && (
																<>
																	<TableCell align="center">
																		<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
																			<Tooltip title="Approve">
																				<CustomButton
																					style={{
																						padding: "8px",
																						width: "50px",
																						display: "flex",
																						alignItems: "center",
																						justifyContent: "center"
																					}}
																					onClick={() =>
																						handleAcceptOrRejectReq(
																							row.customerId,
																							row.userRole,
																							row.companyId,
																							"Approve"
																						)
																					}
																				>
																					{
																						<ThumbUpAltRoundedIcon
																							style={{
																								color: "#fff",
																								fontSize: "20px"
																							}}
																						/>
																					}
																				</CustomButton>
																			</Tooltip>

																			<Tooltip title="Reject">
																				<CustomButton
																					style={{
																						padding: "8px",
																						width: "50px",
																						display: "flex",
																						alignItems: "center",
																						justifyContent: "center"
																					}}
																					onClick={() =>
																						handleAcceptOrRejectReq(
																							row.customerId,
																							row.userRole,
																							row.companyId,
																							"Reject"
																						)
																					}
																				>
																					{
																						<ClearRoundedIcon
																							style={{
																								color: "#fff",
																								fontSize: "28px"
																							}}
																						/>
																					}
																				</CustomButton>
																			</Tooltip>
																		</div>
																	</TableCell>
																</>
															)}

															{row.verificationStatus == "Approve" && (
																<>
																	<TableCell align="center">
																		<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
																			<Tooltip title="Approve">
																				<CustomButton
																					style={{
																						padding: "8px",
																						width: "50px",
																						display: "flex",
																						alignItems: "center",
																						justifyContent: "center"
																					}}
																					disabled
																					onClick={() =>
																						handleAcceptOrRejectReq(
																							row.customerId,
																							row.userRole,
																							row.companyId,
																							"Approve"
																						)
																					}
																				>
																					{
																						<ThumbUpAltRoundedIcon
																							style={{
																								color: "#fff",
																								fontSize: "20px"
																							}}
																						/>
																					}
																				</CustomButton>
																			</Tooltip>

																			<Tooltip title="Reject">
																				<CustomButton
																					style={{
																						padding: "8px",
																						width: "50px",
																						display: "flex",
																						alignItems: "center",
																						justifyContent: "center"
																					}}
																					disabled
																					onClick={() =>
																						handleAcceptOrRejectReq(
																							row.customerId,
																							row.userRole,
																							row.companyId,
																							"Reject"
																						)
																					}
																				>
																					{
																						<ClearRoundedIcon
																							style={{
																								color: "#fff",
																								fontSize: "28px"
																							}}
																						/>
																					}
																				</CustomButton>
																			</Tooltip>
																		</div>
																	</TableCell>
																</>
															)}

															{row.verificationStatus == "Reject" && (
																<>
																	<TableCell
																		align="center"
																	>
																		<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
																			<Tooltip title="Approve">
																				<CustomButton
																					style={{
																						padding: "8px",
																						width: "50px",
																						display: "flex",
																						alignItems: "center",
																						justifyContent: "center"
																					}}
																					disabled={true}
																				>
																					{
																						<ThumbUpAltRoundedIcon
																							style={{
																								color: "#fff",
																								fontSize: "20px"
																							}}
																						/>
																					}
																				</CustomButton>
																			</Tooltip>

																			<Tooltip title="Reject">
																				<CustomButton
																					style={{
																						padding: "4px",
																						width: "48px",
																						marginLeft: "5px"
																					}}
																					disabled={true}
																				>
																					{
																						<ClearRoundedIcon
																							style={{
																								color: "#fff",
																								fontSize: "28px"
																							}}
																						/>
																					}
																				</CustomButton>
																			</Tooltip>
																		</div>
																	</TableCell>
																</>
															)}

															{/* <TableCell>
                            {row.verificationStatus == "Approve" ? (
                              <CustomButton
                                style={{
                                  marginTop: "1rem",
                                  marginLeft: "1rem",
                                }}
                                onClick={() =>
                                  handleAcceptOrRejectReq(
                                    row.customerId,
                                    row.userRole,
                                    row.companyId,
                                    "Approve"
                                  )
                                }
                              >
                                Accept
                              </CustomButton>
                            ) : (
                              <CustomButton
                                style={{
                                  marginTop: "1rem",
                                  marginLeft: "1rem",
                                }}
                                disabled={true}
                              >
                                Accept
                              </CustomButton>
                            )}
                          </TableCell>

                          <TableCell>
                            <CustomButton
                              style={{
                                marginTop: "1rem",
                                marginLeft: "1rem",
                              }}
                              disabled={true}
                            >
                              Reject
                            </CustomButton>
                          </TableCell> */}
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={getKybReportListArray.length}
										rowsPerPage={rowsPerPage}
										page={page}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					)}
				</Layout>
				{getKybApproveRejectRes.data.status == "Approved" && (
					<div>
						<Dialog open={notificationApproveReject} onClose={notificationClose}>
							<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
							
							>
								<img src={success} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{approveRejectDesc}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={notificationClose}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}

				{getKybApproveRejectRes.data.status == "Reject" && (
					<div>
						<Dialog open={notificationApproveReject} onClose={notificationClose}>
							<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
							
							>
								<img src={success} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{approveRejectDesc}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={notificationClose}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				)}
			</>
		</>
	);
};

export default KybReport;
